import { createHashRouter, RouterProvider } from 'react-router-dom';
import { OuterProviders } from '@qcdoc/shared/app/providers.tsx';
import { routes } from './routes.tsx';
import { AppStateProvider } from '../redux/store/AppStateProvider.tsx';

const router = createHashRouter(routes);

export default function App() {
  return <AppStateProvider><OuterProviders><RouterProvider router={router} /></OuterProviders></AppStateProvider>;
}